module.exports = __webpack_public_path__ + "static/media/img-8.e608cd5d.jpg";